import { render, staticRenderFns } from "./ProfessionView.vue?vue&type=template&id=aa9c5570&scoped=true&"
import script from "./ProfessionView.vue?vue&type=script&lang=js&"
export * from "./ProfessionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9c5570",
  null
  
)

export default component.exports